import { Resources } from 'constants/resources';

import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { PageHeader } from 'shared/mui/PageHeader';
import { TypographyTitle } from 'shared/mui/Typography';
import { DirectionValue } from 'types/embedded/direction';

import { useOrderManualCreate } from './hooks/useOrderManualCreate';
import { FormContainerStyled } from './OrderManualCreate.styled';
import { OrderManualCreateGeneralFields } from './OrderManualCreateGeneralFields';
import { OrderManualCreateMerchantFields } from './OrderManualCreateMerchantFields';
import { OrderManualCreateProvidersFields } from './OrderManualCreateProvidersFields';
import { ORDER_MANUAL_CREATE_SCHEMA } from './schemas/schema';

export type OrderManualCreateValues = {
  direction: DirectionValue;
  status: string;
  amount: string;
  createdAt: number | null;
  updatedAt: number | null;
  merchantReferenceId: string;
  providerReferenceId: string;
  customerId: string;
  customerAccount: string;
  // id для ReferenceInput и зависимых фильтров, в запрос не уходят
  currencyId: string;
  countryId: string;
  merchant: string;
  merchantAccount: string;
  provider: string;
  gateway: string;
  method: string;
  // имена для запроса, заполняются через syncFields
  merchantName: string;
  merchantAccountName: string;
  providerName: string;
  gatewayName: string;
  methodName: string;
  currency: string;
  country: string;
};

const defaultValues: Partial<OrderManualCreateValues> = {
  direction: 'payment',
  status: 'success',
  createdAt: null,
  updatedAt: null,
};

export const OrderManualCreate: React.FC = () => {
  const { isLoading, onSubmit } = useOrderManualCreate();

  const form = useForm<OrderManualCreateValues>({
    defaultValues,
    resolver: yupResolver(ORDER_MANUAL_CREATE_SCHEMA) as Resolver<OrderManualCreateValues>,
  });

  return (
    <>
      <PageHeader
        breadCrumbs={{
          listName: 'Заказы',
          resource: Resources.Orders,
          currentPage: 'Ручное создание заказа',
          showCurrentPage: true,
        }}
      />
      <FormContainerStyled>
        <TypographyTitle fontWeight={500} lineHeight={1} size="small">
          Ручное создание заказа
        </TypographyTitle>
        <FormProvider {...form}>
          <form noValidate onSubmit={form.handleSubmit(onSubmit)}>
            <OrderManualCreateGeneralFields />
            <OrderManualCreateMerchantFields />
            <OrderManualCreateProvidersFields />
            <Box display="flex" justifyContent="flex-end">
              <Button disabled={isLoading} label="Создать" type="submit" variant="contained" />
            </Box>
          </form>
        </FormProvider>
      </FormContainerStyled>
    </>
  );
};
